module.exports = __webpack_public_path__ + "static/media/autism-therapy-types.dbeecf80.png";